module.exports = __webpack_public_path__ + "img/CWM-WebsiteTiles-EOTAS-F01-ServiceFlag-72dpi.efe275e7.jpg";